"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _platforms = require("../constants/platforms");

/**
 * @returns True if process is windows.
 */
var isWindows = function isWindows() {
  var isWindowsResult = false;

  try {
    isWindowsResult = process.platform === _platforms.SUPPORTED_PLATFORMS.WIN32;
  } catch (e) {
    isWindowsResult = false;
  }

  return isWindowsResult;
};

var _default = isWindows;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL2lzV2luZG93cy50cyJdLCJuYW1lcyI6WyJpc1dpbmRvd3MiLCJpc1dpbmRvd3NSZXN1bHQiLCJwcm9jZXNzIiwicGxhdGZvcm0iLCJTVVBQT1JURURfUExBVEZPUk1TIiwiV0lOMzIiLCJlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7O0FBRUE7QUFDQTtBQUNBO0FBQ0EsSUFBTUEsU0FBUyxHQUFHLFNBQVpBLFNBQVksR0FBZTtBQUMvQixNQUFJQyxlQUF3QixHQUFHLEtBQS9COztBQUNBLE1BQUk7QUFDRkEsSUFBQUEsZUFBZSxHQUFHQyxPQUFPLENBQUNDLFFBQVIsS0FBcUJDLCtCQUFvQkMsS0FBM0Q7QUFDRCxHQUZELENBRUUsT0FBT0MsQ0FBUCxFQUFVO0FBQ1ZMLElBQUFBLGVBQWUsR0FBRyxLQUFsQjtBQUNEOztBQUNELFNBQU9BLGVBQVA7QUFDRCxDQVJEOztlQVVlRCxTIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU1VQUE9SVEVEX1BMQVRGT1JNUyB9IGZyb20gXCIuLi9jb25zdGFudHMvcGxhdGZvcm1zXCI7XHJcblxyXG4vKipcclxuICogQHJldHVybnMgVHJ1ZSBpZiBwcm9jZXNzIGlzIHdpbmRvd3MuXHJcbiAqL1xyXG5jb25zdCBpc1dpbmRvd3MgPSAoKTogYm9vbGVhbiA9PiB7XHJcbiAgbGV0IGlzV2luZG93c1Jlc3VsdDogYm9vbGVhbiA9IGZhbHNlO1xyXG4gIHRyeSB7XHJcbiAgICBpc1dpbmRvd3NSZXN1bHQgPSBwcm9jZXNzLnBsYXRmb3JtID09PSBTVVBQT1JURURfUExBVEZPUk1TLldJTjMyO1xyXG4gIH0gY2F0Y2ggKGUpIHtcclxuICAgIGlzV2luZG93c1Jlc3VsdCA9IGZhbHNlO1xyXG4gIH1cclxuICByZXR1cm4gaXNXaW5kb3dzUmVzdWx0O1xyXG59O1xyXG5cclxuZXhwb3J0IGRlZmF1bHQgaXNXaW5kb3dzO1xyXG4iXX0=